export default __webpack_public_path__ + "static/media/LineBlack.f1973bdd.svg";